import { ActionMenuItem, stenaMobile } from "@stenajs-webui/elements";
import type { FC } from "react";

interface SendBookingActionMenuItemProps {
  disabled?: boolean | undefined;
  onClick: () => void;
}

export const SendBookingActionMenuItem: FC<SendBookingActionMenuItemProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <ActionMenuItem
      label={"Send to Driver app"}
      leftIcon={stenaMobile}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
